<template>
  <div class="enterprise-page">
    <PageSwiper location="INTRO"/>
    <router-view/>
  </div>
</template>
<script>
import PageSwiper from '@/components/PageSwiper'
export default {
  components: {PageSwiper},
  data() {
    return {
      
    }
  },
  created() {
  },
  methods: {
    
  }
}
</script>
<style lang="scss" scoped>
.enterprise-page {
  padding-bottom: 100px;
}
</style>
